<template>
  <div class="footer">
    <div class="banxin">
      <div class="top" :style="{ display: ['-webkit-box', '-ms-flexbox', 'flex'] }">
          <!-- <div class="leftBox">
              <p class="title">客服电话</p>
              <p class="number">+ 86 189 2289 1559</p>
              <div class="consult">咨询客服</div>
          </div>
          <div class="centerBox">
              <p class="title">关注我们</p>
              <p>专注于客单价，转化率提升！</p>
              <p>便捷高效，助力各大商家提升客单价，</p>
              <p>客户引导，提高复购，</p>
              <p>只为更好的服务每一位用户。</p>
          </div>
          <div class="rightBox" :style="{ display: ['-webkit-box', '-ms-flexbox', 'flex'] }">
              <div class="aboutUs">
                  <p class="title">关于我们</p>
                  <p class="cur-poi">了解我们</p>
                  <p class="cur-poi">合作咨询</p>
                  <p class="cur-poi">联系我们</p>
              </div>
              <div class="qrCode">
                  <p class="title">下载</p>
                  <img src="../../static/image/qrcode.png" alt="">
              </div>
          </div> -->
      </div>
      <p class="bottom">&copy;2018-2028版权所有，并保留所有权利 粤ICP备2024300073号-1</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #D63C37;
  overflow: hidden;
  text-align: center;
  .banxin{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    .top {
      margin-top: 20px;
      display: flex !important;
      flex-direction: row;
      margin-bottom: 20px;
      text-align: center;
      .leftBox {
        flex: 1;
        display: flex !important;
        flex-direction: column;
        .title {
          font-size: 16px;
          margin-bottom: 33px;
        }
        .number{
          font-size: 30px;
          margin-bottom: 8px;
          font-weight: 500;
        }
        .time{
          font-size: 18px;
          margin-bottom: 23px;
        }
        .consult {
          cursor: pointer;
          margin: 0 auto;
          width: 220px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #FFFFFF;
          box-sizing: border-box;
          opacity: 0.6;
        }
      }
      .centerBox{
        flex: 1;
        border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
        border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
        p {
            font-size: 16px;
            line-height: 25px;
        }
        .title {
            margin-bottom: 33px;
        }
      }
      .rightBox {
        flex: 1;
        display: flex !important;
        flex-direction: row;
        align-items: center;
        .aboutUs {
          flex: 1;
          p{
              margin-bottom: 20px;
          }
          .title {
              margin-bottom: 33px;
          }
        }
        .qrCode{
          flex: 1;
          .title{
              margin-bottom: 33px;
          }
          img {
            margin-left: 35px;
              width: 106px;
              height: 106px;
          }
        }
      }
    }
    .bottom{
        text-align: center;
        font-size: 12px;
        line-height: 24px;
        color: #FFFFFF;
    }
  }
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 16px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue